// ======================================================================
// File Name       : tabMenu
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const TABMENU_SAVE_ACTIVE_TAB = 'TABMENU_SAVE_ACTIVE_TAB';
export const REPORT_TABMENU_SAVE_ACTIVE_TAB = 'REPORT_TABMENU_SAVE_ACTIVE_TAB';